import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../../domain/services/breadcrumb/breadcrumb.service';
import { NotificationTemplateService } from '../../../domain/services/admin/notification-template.service';
import { NotificationTemplateModel } from '../../../domain/models/notification-template.model';

@Component({
  selector: 'app-notification-templates',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
  ],
  templateUrl: './notification-templates.component.html',
  styleUrl: './notification-templates.component.css',
})
export class NotificationTemplatesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<NotificationTemplateModel>;

  displayedColumns = ['displayName', 'subject', 'channel', 'tokens', 'actions'];
  dataSource = new MatTableDataSource<NotificationTemplateModel>([]);

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly templateService: NotificationTemplateService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([
      { icon: 'account_balance', url: '/app/admin/notification-templates', label: 'Administrative' },
      { icon: 'mail', url: '/app/admin/notification-templates', label: 'Automatic notifications' },
    ]);
    this.loadTemplates();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  loadTemplates(): void {
    this.templateService.getTemplates().subscribe((templates) => {
      this.dataSource.data = templates;
    });
  }

  onEdit(row: NotificationTemplateModel): void {
    this.router.navigate(['/app/admin/notification-templates', row.code]);
  }

  goBack(): void {
    window.history.back();
  }
}
